// NOTE: this util capitalizes the first letter of each word
export const capitalize = (str: string) => {
	return str
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

// NOTE: this util capitalizes only the first letter of the string
export const capitalizeFirst = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

// NOTE: this util transforms an underscore-separated string to sentence case
// e.g. 'department_name' -> 'Department name'
export const transformCustomPropertyToString = (str?: string) => {
	if (!str) return '';
	return capitalizeFirst(str.replace(/_/g, ' '));
};

export const convertUnderscoreToCamelCase = (str: string) => {
	return str.replace(/_([a-z])/g, (_, char) => char.toUpperCase());
};

export const toSnakeCase = (str: string): string => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
